import { combineReducers, configureStore } from '@reduxjs/toolkit'
import storageSession from 'redux-persist/lib/storage/session'
import { userReducer } from 'features/Authentication'
import { cartReducer } from 'features/Health/cart.health.slice'
import { memberDetailsReducer } from 'features/Health/memberDetails.health.slice'
import { homePageReducer } from 'features/Home'
import { vehicleDetailsReducer, quotationsReducer, proposalPageReducer } from 'features/Motor'
import { authenticationApi } from 'Services/API/authentication.api'
import { healthApi } from 'Services/API/health.api'
import { motorApi } from 'Services/API/motor.api'
import persistReducer from 'redux-persist/es/persistReducer'
import { ckycReducer } from 'features/User/ckyc.slice'
import { pospApi } from 'Services/API/posp.api'

const persistConfig = {
  key: `STORE_${process.env.REACT_APP_ENV}`,
  storage: storageSession,
  blacklist: ['pospApi'],
}

const reducers = combineReducers({
  user: userReducer,
  homePage: homePageReducer,
  vehicleDetails: vehicleDetailsReducer,
  quotationsDetails: quotationsReducer,
  proposalPage: proposalPageReducer,
  ckyc: ckycReducer,
  [authenticationApi.reducerPath]: authenticationApi.reducer,
  memberDetails: memberDetailsReducer,
  cart: cartReducer,
  [healthApi.reducerPath]: healthApi.reducer,
  [motorApi.reducerPath]: motorApi.reducer,
  [pospApi.reducerPath]: pospApi.reducer,
})

const persistedReducer = persistReducer(persistConfig, reducers)

export const store: any = configureStore({
  reducer: persistedReducer,
  middleware: (gDM) =>
    gDM({ serializableCheck: false }).concat(
      authenticationApi.middleware,
      motorApi.middleware,
      healthApi.middleware,
      pospApi.middleware,
    ),
  devTools: process.env.NODE_ENV !== 'production',
})

export type AppDispatch = typeof store.dispatch
export type RootState = ReturnType<typeof store.getState>
